import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { trackerApi } from "@/api/trackerApi";

export const fetchEntries = createAsyncThunk("tracker/fetchAll", () =>
  trackerApi.list(),
);
export const fetchActive = createAsyncThunk("tracker/fetchActive", () =>
  trackerApi.getActive(),
);
export const startTimer = createAsyncThunk(
  "tracker/start",
  (data: { description?: string; projectId: string }) =>
    trackerApi.create({ ...data, from: new Date().toISOString() }),
);
export const stopTimer = createAsyncThunk("tracker/stop", (id: string) =>
  trackerApi.update(id, { through: new Date().toISOString() }),
);
export const createEntry = createAsyncThunk(
  "tracker/create",
  (data: {
    description?: string;
    projectId: string;
    from: string;
    through: string;
    billable?: boolean;
  }) => trackerApi.create(data),
);
export const deleteEntry = createAsyncThunk("tracker/delete", (id: string) =>
  trackerApi.remove(id).then(() => id),
);

const trackerSlice = createSlice({
  name: "tracker",
  initialState: { list: [] as any[], active: null as any, loading: false },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchEntries.pending, (s) => {
      s.loading = true;
    })
      .addCase(fetchEntries.fulfilled, (s, a) => {
        s.list = a.payload;
        s.loading = false;
      })
      .addCase(fetchEntries.rejected, (s) => {
        s.loading = false;
      })
      .addCase(fetchActive.fulfilled, (s, a) => {
        s.active = a.payload;
      })
      .addCase(startTimer.fulfilled, (s, a) => {
        s.active = a.payload;
        s.list.unshift(a.payload);
      })
      .addCase(stopTimer.fulfilled, (s, a) => {
        s.active = null;
        const idx = s.list.findIndex((e: any) => e.id === a.payload.id);
        if (idx >= 0) s.list[idx] = a.payload;
      })
      .addCase(createEntry.fulfilled, (s, a) => {
        s.list.unshift(a.payload);
      })
      .addCase(deleteEntry.fulfilled, (s, a) => {
        s.list = s.list.filter((e: any) => e.id !== a.payload);
      });
  },
});

export default trackerSlice.reducer;
